import React, {
  Dispatch,
  SetStateAction,
  useContext,
  createContext,
  useState,
  useMemo,
} from 'react';

type SignUpContextValues = {
  signUpValues: Record<string, any>;
  addSignUpValues: Dispatch<SetStateAction<any>>;
};

export const SignUpContext = createContext<SignUpContextValues>({
  signUpValues: {},
  addSignUpValues: () => undefined,
});

export const useSignUpContext = () => useContext(SignUpContext);

export const Provider = props => {
  const [signUpValues, setSignUpValues] = useState({});
  const addSignUpValues = newValues =>
    setSignUpValues(lastValues => {
      return { ...lastValues, ...newValues };
    });

  const value = useMemo(
    () => ({ signUpValues, addSignUpValues }),
    [signUpValues, addSignUpValues]
  );

  return <SignUpContext.Provider value={value} {...props} />;
};
